export const uiIcons = {
  actions: {
    add: 'add',
    edit: 'edit',
    delete: 'delete',
    save: 'save',
    cancel: 'cancel',
    close: 'close',
    archive: 'archive',
    duplicate: 'copy_all',
    copy: 'content_copy',
    share: 'share',
    download: 'download',
    upload: 'upload',
    search: 'search',
    reset: 'replay',
    bookmark: 'bookmark',
  },
  navigation: {
    next: 'chevron_right',
    back: 'chevron_left',
    openExternal: 'open_in_new',
    home: 'home',
    menu: 'menu',
    externalLink: 'open_in_new',
  },
  status: {
    info: 'info',
    error: 'error',
    errorOutline: 'error_outline',
    warning: 'warning',
    success: 'check_circle',
    confirm: 'check',
  },
  controls: {
    filter: 'filter_list',
    moreOptionsVertical: 'more_vert',
    moreOptionsHorizontal: 'more_horiz',
    setDefault: 'stack_star',
    settings: 'settings',
    columnPicker: 'tune',
    gridView: 'grid_view',
    tableView: 'table_rows',
    expand: 'expand_content',
    expandDown: 'keyboard_arrow_down',
    forward: 'arrow_forward',
  },
  state: {
    locked: 'lock',
    disabled: 'do_not_disturb_on',
    searchEmpty: 'search_off',
    away: 'account_circle_off',
  },
  healthStatus: {
    onTrack: 'signal_cellular_alt',
    pending: 'hourglass_empty',
    health: 'monitor_heart',
    atRisk: 'earthquake',
  },
  file: {
    attach: 'attach_file_add',
    unavailable: 'file_download_off',
  },
  keys: {
    enter: 'keyboard_return',
  },
  metadata: {
    lastActivity: 'linear_scale',
    created: 'line_start_circle',
    dashboard: 'dashboard_2',
    owner: 'article_person',
    sharedWith: 'group',
    location: 'location_chip',
  },
  content: {
    feedback: 'feedback',
    tip: 'lightbulb_circle',
    quote: 'format_quote',
  },
  organization: {
    department: 'brick',
    legalEntity: 'borg',
    hierarchy: 'account_tree',
    employment: 'work',
    skills: 'design_services',
  },
  release: {
    new: 'brand_awareness',
  },
} as const;
